import log from 'salvo-lite/log'

class StoreFilter {
    constructor (theme, elem) {
        this._elem = elem
        this._name = this._elem.getAttribute('data-store-filter')
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        var name = this._name || ''
        if (name !== '') {
            var radios = document.getElementsByName(name)

            radios.forEach(function (ele) {
                ele.addEventListener('change', (event) => {
                    for (var i = 0, length = radios.length; i < length; i++) {
                        if (radios[i].checked) {
                            // do whatever you want with the checked radio
                            document.querySelector('.stores_result > .container').style.display = 'block'

                            var stores = document.querySelectorAll('.store')
                            var count = 0

                            stores.forEach((store) => {
                                if (store.getAttribute('data-store-location') === radios[i].value) {
                                    store.style.display = 'block'
                                    count++
                                } else {
                                    store.style.display = 'none'
                                }
                            })

                            document.querySelector('.stores_heading span').innerHTML = count

                            // only one radio can be logically checked, don't check the rest
                            break
                        }
                    }
                })
            })
        }
    }
}

export default StoreFilter



// WEBPACK FOOTER //
// ./src/resources/scripts/components/StoreFilter.js